module.exports = __webpack_public_path__ + "img/br3zj.0f2a1a57.png";